import React from 'react';
import { Body2 } from '@gousto-internal/citrus-react';

interface RecipeCookTimeProps {
  cookTime: string | null;
}

export function RecipeCookTime(props: RecipeCookTimeProps) {
  if (!props.cookTime) {
    return null;
  }

  return <Body2 data-testid="recipe-cook-time">{props.cookTime}</Body2>;
}
